"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.settings.title': 'Apri Impostazioni',
    'shortcuts.settings.description': 'Apre il pannello delle impostazioni per configurare le tue preferenze',
};
